var map = {
	"./BexenCardio_Settings.png": 8363,
	"./logo.png": 6949,
	"./profile_info.png": 6195,
	"./profile_info_min.png": 4417,
	"./settingsProfile.png": 3460,
	"./settingsProfile_min.png": 4596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;